// src/utils/pwaDetection.ts

/**
 * Detect if app is running as installed PWA
 */
export const isPWA = (): boolean => {
  // Standard display mode check
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  // iOS Safari specific
  const isIOSStandalone = (window.navigator as any).standalone === true;

  // Android Chrome specific
  const isAndroidStandalone = document.referrer.includes('android-app://');

  return isStandalone || isIOSStandalone || isAndroidStandalone;
};

/**
 * Get stable device fingerprint
 * For PWA: device-specific identifier to bind refresh tokens
 */
export const getDeviceFingerprint = (): string => {
  const stored = localStorage.getItem('deviceFingerprint');
  if (stored) return stored;

  // Generate stable fingerprint
  const components = [
    navigator.userAgent,
    navigator.language,
    // eslint-disable-next-line no-restricted-globals
    screen.width,
    // eslint-disable-next-line no-restricted-globals
    screen.height,
    // eslint-disable-next-line no-restricted-globals
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    Date.now().toString() // Makes it unique per device
  ];

  const fingerprint = components.join('|');
  const hash = btoa(fingerprint).substring(0, 32);

  localStorage.setItem('deviceFingerprint', hash);
  return hash;
};

/**
 * Get complete device context for authentication
 */
export const getDeviceContext = () => {
  const isPWAMode = isPWA();
  const ctx = {
    isPWA: isPWAMode,
    deviceId: getDeviceFingerprint(),
    platform: navigator.platform,
    userAgent: navigator.userAgent,
    // eslint-disable-next-line no-restricted-globals
    screenResolution: `${screen.width}x${screen.height}`,
    language: navigator.language,
    timestamp: Date.now(),
    clientType: (isPWAMode ? 'pwa' : 'web') as 'pwa' | 'web'
  };

  if (process.env.NODE_ENV !== 'production') {
    console.log('deviceContext:', ctx);
  }

  return ctx;
};

/**
 * Get client type for headers
 */
export const getClientType = (): 'pwa' | 'web' => {
  return isPWA() ? 'pwa' : 'web';
};
